module.exports = __webpack_public_path__ + "static/assinatura-digital-tab-e3821b3bb6ce36aa5269f260ba49e57d.png";